"use client"

// Lightweight wrapper for SweetAlert2 with lazy import to avoid SSR issues
// Usage: import { alerts } from '@/lib/alerts'
// Then: await alerts.success('Título', 'Mensaje opcional')

type AlertOptions = { timerMs?: number; requireConfirm?: boolean }

export const alerts = {
  async success(title: string, text?: string, opts?: AlertOptions) {
    const Swal = (await import('sweetalert2')).default
    return Swal.fire({
      icon: 'success',
      title,
      text,
      confirmButtonColor: '#14b8a6',
      confirmButtonText: 'Aceptar',
      showConfirmButton: true,
      timer: opts?.requireConfirm ? undefined : opts?.timerMs ?? 2000,
      timerProgressBar: opts?.requireConfirm ? false : (opts?.timerMs ? true : true),
    })
  },

  async error(title: string, text?: string, opts?: AlertOptions) {
    const Swal = (await import('sweetalert2')).default
    return Swal.fire({
      icon: 'error',
      title,
      text,
      confirmButtonColor: '#ef4444',
      confirmButtonText: 'Entendido',
      timer: opts?.requireConfirm ? undefined : opts?.timerMs,
      timerProgressBar: !!opts?.timerMs && !opts?.requireConfirm,
    })
  },

  async info(title: string, text?: string, opts?: AlertOptions) {
    const Swal = (await import('sweetalert2')).default
    return Swal.fire({
      icon: 'info',
      title,
      text,
      confirmButtonColor: '#14b8a6',
      confirmButtonText: 'Aceptar',
      timer: opts?.requireConfirm ? undefined : opts?.timerMs,
      timerProgressBar: !!opts?.timerMs && !opts?.requireConfirm,
    })
  },

  async confirm(title: string, text?: string, opts?: { confirmText?: string; cancelText?: string }) {
    const Swal = (await import('sweetalert2')).default
    const result = await Swal.fire({
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#14b8a6',
      cancelButtonColor: '#6b7280',
      confirmButtonText: opts?.confirmText || 'Confirmar',
      cancelButtonText: opts?.cancelText || 'Cancelar',
      reverseButtons: true,
      focusCancel: true,
    })
    return result.isConfirmed
  },
}
